
const buildUrlParameters = (mappedUrlParameters) => {
    const queryString = new URLSearchParams(mappedUrlParameters).toString();
    return`?${queryString}`
}

const updateUrlParametersAndReload = (mappedUrlParameters) => {
    const url = buildUrlParameters(mappedUrlParameters)
    window.location.href = url
}

const updateUrlParameters = (mappedUrlParameters) => {
    const url = buildUrlParameters(mappedUrlParameters)
    window.history.replaceState(null, '', url);
}

const pushUrlParameters = (mappedUrlParameters) => {
    const currentParams = new URLSearchParams(window.location.search);

    Object.entries(mappedUrlParameters).forEach(([key, value]) => {
        currentParams.set(key, value);
    });

    const mappedParams = Object.fromEntries(currentParams.entries());
    updateUrlParametersAndReload(mappedParams);
};

const getTableData = (tablesData) => {
    return tablesData.map(table => ({
        tooltip: table.header.tooltip,
        header: getTableHeader(table.header),
        rows: getTableRows(table.rows)
    }));
};

const getTableRows = (rowsData) => {
    const rows = []

    rowsData.forEach(row => {
        rows.push({
            hide: row.hide,
            row: [{ name: row.title }, { name: row.value, styles: 'text-right' }],
        })
    })

    return rows
}

const getTableHeader = (headerData) => {
    const header = []
    if (headerData.tooltip) {
        header.push({
            name: `<h3>${headerData.title}</h3>`,
            scope: 'row',
            tooltip: headerData.tooltip,
            tooltipTitle: headerData.title,
            styles: 'tooltip',
        })
    } else {
        header.push({ name: `<h3>${headerData.title}</h3>`, scope: 'row' })
    }
    return header
}

export {
    getTableData,
    pushUrlParameters,
    buildUrlParameters,
    updateUrlParameters,
    updateUrlParametersAndReload
}